import React from 'react';
import { TypographyFontWeight, TypographyVariant, } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import Row from '../layout/Row';
import Pressable from '../pressables/Pressable';
import Typography from '../typography/Typography';
const BreadCrumbs = ({ crumbs, visibleCount = 2, ...rowProps }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const validCrumbs = crumbs
        .filter((crumb) => crumb !== null && crumb !== false && crumb !== undefined)
        .map((crumb) => typeof crumb === 'string' ? { label: crumb } : crumb);
    const pathCrumbs = validCrumbs.slice(-Math.min(visibleCount, validCrumbs.length), -1);
    const lastCrumb = validCrumbs[validCrumbs.length - 1];
    const renderPathCrumb = (crumb, index) => {
        const label = (React.createElement(Typography, { variant: TypographyVariant.CAPTION, fontWeight: TypographyFontWeight.MEDIUM, color: crumb.to ? theme.palette.primary.dark : theme.palette.typography.secondary }, crumb.label.trim()));
        if (crumb.to) {
            return (React.createElement(Pressable, { key: `path_${index}_${crumb.label}`, to: crumb.to }, label));
        }
        return (React.createElement(React.Fragment, { key: `path_${index}_${crumb.label}` }, label));
    };
    const renderPath = () => {
        const pathComponents = [];
        for (let i = 0; i < pathCrumbs.length; ++i) {
            pathComponents.push(renderPathCrumb(pathCrumbs[i], i));
            pathComponents.push(React.createElement(Typography, { key: `sep_${i}`, variant: TypographyVariant.CAPTION },
                ' ',
                "/",
                ' '));
        }
        return pathComponents;
    };
    return (React.createElement(Row, { pv: theme.spacing.standard.xxs, bg: theme.palette.background.main, ...rowProps },
        React.createElement(Typography, null,
            renderPath(),
            lastCrumb && (React.createElement(Typography, { key: "heading", variant: TypographyVariant.CAPTION, fontWeight: TypographyFontWeight.MEDIUM, color: theme.palette.typography.secondary, accessibilityRole: "header", "aria-level": 2 }, lastCrumb.label.trim())))));
};
const stylesGenerator = createThemedStyle(() => ({}));
export default BreadCrumbs;
